// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperNewsStory-cls1_mW0","cls2":"PaperNewsStory-cls2_4nA PaperNewsStory-cls1_mW0"};